import { Input, InputNumber, Modal } from "antd";
import { useEffect, useState } from "react";
import useWsSender from "lib/wsSenderHook";
import { showToast } from "ui/components/common";
import { SvgCustomForward } from "ui/svgs";

export default function ({ deviceId, orgId }) {
  const [ip, setIp] = useState("");
  const [port, setPort] = useState(80);
  const [modalShow, setModalShow] = useState(false);
  const { sendWsRequest } = useWsSender();
  const [loading, setLoading] = useState(false);
  const deviceForward = async () => {
    try {
      setLoading(true);
      setModalShow(false);
      const res: any = await sendWsRequest(
        "device.remote_service.open",
        {
          deviceOpenRemoteService: {
            deviceId: deviceId.toString(),
            deviceType: "type_unknown",
            network: { ip, port },
          },
        },
        { orgId },
      );
      const query =
        "?expiredAt=" +
        res.deviceOpenRemoteServiceReply.cookie.expiredAt +
        "&name=" +
        res.deviceOpenRemoteServiceReply.cookie.name +
        "&value=" +
        res.deviceOpenRemoteServiceReply.cookie.value;
      window.open(
        "https://" + res.deviceOpenRemoteServiceReply.domain + query,
        "_blank",
      );
      setModalShow(false);
    } catch (e) {
      console.error(e);
      showToast(1, "Forward failed");
    } finally {
      setLoading(false);
    }
    return;
  };
  useEffect(() => {
    if (!modalShow) return;
    setIp("");
    setPort(80);
  }, [modalShow]);
  return (
    <>
      <span
        onClick={(event) => {
          event.stopPropagation();
          setModalShow(true);
        }}
      >
        {loading ? (
          <div
            className="ml-1 text-neutral-800  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          ></div>
        ) : (
          <SvgCustomForward className="" />
        )}
      </span>
      <Modal
        title={"Forward to device"}
        open={modalShow}
        okButtonProps={{ className: "primaryButton" }}
        cancelButtonProps={{ className: "primaryButton bordered" }}
        onCancel={() => setModalShow(false)}
        onOk={deviceForward}
      >
        <div style={{ marginTop: "12px" }}>
          <span>{"IP: "}</span>
          <Input
            value={ip}
            onChange={(e) => setIp(e.target.value)}
            style={{ width: "200px" }}
          />
        </div>
        <div style={{ marginTop: "12px" }}>
          <span>{"Port: "}</span>
          <InputNumber value={port} onChange={(e) => setPort(e)} />
        </div>
      </Modal>
    </>
  );
}
